/**
 * Vista: Detalle/Nueva Encuesta de Satisfacción del Producto
 * Formato: AMX-PVTA-FR-04_R4
 */

import posventaService from '../services/posventa.service.js';
import tractorService from '../services/tractor.service.js';
import recepcionService from '../services/recepcion.service.js';
import personaService from '../services/persona.service.js';
import api from '../services/api.js';
import router from '../router/router.js';
import permisos from '../services/permissions.service.js';

import { hoyLocal } from '../utils/fechas.js';
export default {
  data: {
    encuesta: null,
    tractor: null,
    isNew: false,
    distribuidores: [],
    responsablesPosventa: [],
    responsablesCalidad: []
  },

  async render(params) {
    this.data.isNew = !params.id || params.id === 'nueva';

    return `
      <div class="card">
        <div class="card-header" style="display: flex; justify-content: space-between; align-items: center;" id="encuestaHeader">
          <h2 class="card-title">${this.data.isNew ? 'Nueva Encuesta de Producto' : 'Encuesta de Satisfacción del Producto'}</h2>
          <div id="headerButtons" style="display: flex; gap: 0.5rem;">
            <button class="btn btn-secondary" onclick="window.encuestaProductoDetalleView.volver()">Volver</button>
          </div>
        </div>
        <div id="encuestaContent"><div style="text-align: center; padding: 2rem;">Cargando...</div></div>
      </div>
    `;
  },

  async afterRender(params) {
    window.encuestaProductoDetalleView = this;
    this.params = params;
    await this.cargarResponsables();
    if (this.data.isNew) {
      this.renderFormularioNuevo();
    } else {
      await this.cargarEncuesta(params.id);
    }
  },

  async cargarResponsables() {
    try {
      // Distribuidores y responsables desde usuarios con persona asociada (patrón unificado).
      const usuariosResp = await api.get('/usuarios/responsables');
      const todos = Array.isArray(usuariosResp.data) ? usuariosResp.data : (usuariosResp.data?.usuarios || []);
      const usuariosConPersona = todos
        .filter(u => u.persona_id)
        .map(u => ({ id: u.persona_id, nombre_completo: u.persona_nombre_completo || u.nombre_completo }));

      this.data.distribuidores = usuariosConPersona;
      this.data.responsablesPosventa = usuariosConPersona;
      this.data.responsablesCalidad = usuariosConPersona;
    } catch (error) {
      console.error('Error al cargar responsables:', error);
      this.data.distribuidores = [];
      this.data.responsablesPosventa = [];
      this.data.responsablesCalidad = [];
    }
  },

  async cargarEncuesta(id) {
    try {
      const response = await posventaService.obtenerEncuestaProducto(id);
      this.data.encuesta = response.data || response;

      if (this.data.encuesta.completada) {
        this.renderEncuestaCompletada();
      } else {
        this.renderFormularioEdicion();
      }
    } catch (error) {
      toast.error('Error al cargar encuesta');
      router.navigate('/posventa/encuestas-producto');
    }
  },

  injectStyles() {
    if (document.querySelector('style[data-encuesta-producto-tabs]')) return;
    const style = document.createElement('style');
    style.setAttribute('data-encuesta-producto-tabs', '');
    style.textContent = `
      .encuesta-tabs-bar { display: flex; padding: 0; background: transparent; border-bottom: 2px solid #e5e7eb; margin-bottom: 1rem; }
      .encuesta-tab { flex: 1; padding: 0.6rem 1rem; border: none; border-bottom: 3px solid transparent; margin-bottom: -2px; background: transparent; color: #6b7280; font-size: 0.875rem; font-weight: 500; cursor: pointer; transition: all 0.2s ease; text-align: center; }
      .encuesta-tab:hover:not(.active) { color: #374151; border-bottom-color: #d1d5db; }
      .encuesta-tab.active { color: var(--primary); font-weight: 600; border-bottom-color: var(--primary); }
      .encuesta-radio-group { display: flex; gap: 1rem; margin-top: 0.5rem; flex-wrap: wrap; }
      .encuesta-radio-label { display: flex; align-items: center; gap: 0.25rem; cursor: pointer; }
      .encuesta-radio-hint { color: var(--text-muted); font-size: 0.875rem; }
      .encuesta-detalle-row { display: flex; justify-content: space-between; align-items: center; gap: 0.5rem; border-bottom: 1px solid var(--border-color); padding: 0.5rem 0; }
      .encuesta-detalle-row:last-child { border-bottom: none; }
      .encuesta-row-2col { display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; }
      .encuesta-buscar-tractor { display: flex; gap: 1rem; align-items: center; }
      @media (max-width: 640px) {
        .encuesta-tabs-bar { display: grid; grid-template-columns: 1fr 1fr; gap: 0.3rem; padding: 0.3rem; }
        .encuesta-tab { padding: 0.4rem 0.5rem; font-size: 0.75rem; }
        .encuesta-radio-group { gap: 0.5rem; }
        .encuesta-detalle-row { flex-direction: column; align-items: flex-start; gap: 0.25rem; }
        .encuesta-row-2col { grid-template-columns: 1fr; }
      }
    `;
    document.head.appendChild(style);
  },

  renderRating(name, required = true, disabled = false) {
    const dis = disabled ? 'disabled' : '';
    const req = required ? 'required' : '';
    return `
      <div class="encuesta-radio-group">
        ${[1, 2, 3, 4, 5].map(n => `
          <label class="encuesta-radio-label">
            <input type="radio" name="${name}" value="${n}" ${req} ${dis} />
            <span>${n}</span>
          </label>
        `).join('')}
        <span class="encuesta-radio-hint">(1=Malo, 5=Excelente)</span>
      </div>
    `;
  },

  renderRatingEdit(name, value, disabled = false) {
    const dis = disabled ? 'disabled' : '';
    return `
      <div class="encuesta-radio-group">
        ${[1, 2, 3, 4, 5].map(n => `
          <label class="encuesta-radio-label">
            <input type="radio" name="${name}" value="${n}" ${value == n ? 'checked' : ''} ${dis} />
            <span>${n}</span>
          </label>
        `).join('')}
        <span class="encuesta-radio-hint">(1=Malo, 5=Excelente)</span>
      </div>
    `;
  },

  renderBoolEdit(name, value, labelSi = 'Sí', labelNo = 'No', disabled = false, onchange = '') {
    const dis = disabled ? 'disabled' : '';
    const checkedSi = value === true || value === 1 ? 'checked' : '';
    const checkedNo = value === false || value === 0 ? 'checked' : '';
    return `
      <div class="encuesta-radio-group">
        <label class="encuesta-radio-label"><input type="radio" name="${name}" value="true" ${checkedSi} ${dis} ${onchange} /> <span>${labelSi}</span></label>
        <label class="encuesta-radio-label"><input type="radio" name="${name}" value="false" ${checkedNo} ${dis} ${onchange} /> <span>${labelNo}</span></label>
      </div>
    `;
  },

  // =====================================================
  // FORMULARIO NUEVO
  // =====================================================

  renderFormularioNuevo() {
    const container = document.getElementById('encuestaContent');
    const hoy = hoyLocal();

    container.innerHTML = `
      <form id="formEncuesta">
        <!-- Buscar Tractor -->
        <div style="background: white; border: 1px solid var(--gray-200); padding: 1.25rem 1.5rem; border-radius: 8px; margin-bottom: 1rem;">
          <h4 style="margin: 0 0 0.25rem; font-size: 1rem; font-weight: 600;">Buscar por número de serie</h4>
          <p style="margin: 0 0 1rem; color: var(--text-muted); font-size: 0.85rem;">Ingrese el número de serie del tractor para cargar sus datos automáticamente</p>
          <div style="display: flex; gap: 0.75rem; align-items: center;">
            <input
              type="text"
              id="numSerieBuscar"
              class="form-input"
              style="flex: 1;"
              placeholder="Ej: TE354-2026-0127"
            />
            <button type="button" class="btn btn-primary" onclick="window.encuestaProductoDetalleView.buscarTractor()">
              Buscar
            </button>
          </div>
          <div id="tractorResult" style="margin-top: 1rem;"></div>
        </div>

        <div id="formularioPrincipal" style="display: none;">
          <input type="hidden" name="num_serie" id="numSerie" />

          <!-- Datos -->
          <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem; margin-top: -0.5rem;">
            <h3 style="margin-bottom: 1rem;">Datos de Identificación</h3>
            <div class="encuesta-row-2col" style="margin-bottom: 1rem;">
              <div class="form-group">
                <label class="form-label">Marca</label>
                <input type="text" id="marcaDisplay" class="form-input" readonly style="background: var(--bg-primary);" />
                <input type="hidden" name="marca" id="marca" />
              </div>
              <div class="form-group">
                <label class="form-label">Modelo</label>
                <input type="text" name="modelo" id="modelo" class="form-input" readonly style="background: var(--bg-primary);" />
              </div>
            </div>
            <div class="encuesta-row-2col" style="margin-bottom: 1rem;">
              <div class="form-group">
                <label class="form-label">Usuario (Propietario) *</label>
                <input type="text" name="usuario" id="usuario" class="form-input" />
              </div>
              <div class="form-group">
                <label class="form-label">Distribuidor *</label>
                <select name="distribuidor" class="form-select">
                  <option value="">Seleccione un distribuidor...</option>
                  ${(this.data.distribuidores || []).map(d => `
                    <option value="${d.nombre_completo}">${d.nombre_completo}</option>
                  `).join('')}
                </select>
              </div>
            </div>
            <div class="encuesta-row-2col" style="margin-bottom: 1rem;">
              <div class="form-group">
                <label class="form-label">Fecha de Entrega *</label>
                <input type="date" name="fecha_entrega" id="fechaEntrega" class="form-input" readonly style="background: var(--bg-primary);" />
              </div>
              <div class="form-group">
                <label class="form-label">Fecha de Evaluación *</label>
                <input type="date" name="fecha_evaluacion" class="form-input" value="${hoy}" />
              </div>
            </div>
            <div class="encuesta-row-2col">
              <div class="form-group">
                <label class="form-label">Horas de Uso *</label>
                <input type="number" name="horas_uso" class="form-input" min="100" />
              </div>
              <div class="form-group">
                <label class="form-label">Último Servicio</label>
                <input type="text" name="ultimo_servicio" class="form-input" placeholder="Ej: 350 hr" />
              </div>
            </div>
          </div>

          <!-- Tabs -->
          <div class="encuesta-tabs-bar" id="tabsBarNuevo">
            <button type="button" class="encuesta-tab active" onclick="window.encuestaProductoDetalleView.showTab('evaluacion')">Evaluación</button>
            <button type="button" class="encuesta-tab" onclick="window.encuestaProductoDetalleView.showTab('falla')">Falla</button>
            <button type="button" class="encuesta-tab" id="tabMantenimientoNuevo" style="display: none;" onclick="window.encuestaProductoDetalleView.showTab('mantenimiento')">Mantenimiento</button>
            <button type="button" class="encuesta-tab" onclick="window.encuestaProductoDetalleView.showTab('observaciones')">Observaciones</button>
            <button type="button" class="encuesta-tab" onclick="window.encuestaProductoDetalleView.showTab('responsables')">Responsables</button>
          </div>

          <!-- Panel: Evaluación (P1-P4) -->
          <div class="encuesta-panel" id="panel-evaluacion" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem;">
            <div class="form-group" style="margin-bottom: 1.5rem;">
              <label class="form-label">1. ¿Su equipo cumplió con las expectativas de calidad y rendimiento?</label>
              ${this.renderRating('p1_calidad_rendimiento', false)}
            </div>
            <div class="form-group" style="margin-bottom: 1.5rem;">
              <label class="form-label">2. ¿Su equipo cumplió con las expectativas de funcionamiento y potencia?</label>
              ${this.renderRating('p2_funcionamiento_potencia', false)}
            </div>
            <div class="form-group" style="margin-bottom: 1.5rem;">
              <label class="form-label">3. ¿Recomendaría nuestros productos AGROMX?</label>
              <div class="encuesta-radio-group">
                <label class="encuesta-radio-label"><input type="radio" name="p3_recomendaria" value="true" /> <span>Sí</span></label>
                <label class="encuesta-radio-label"><input type="radio" name="p3_recomendaria" value="false" /> <span>No</span></label>
              </div>
            </div>
            <div class="form-group">
              <label class="form-label">4. ¿Su equipo ha presentado alguna falla?</label>
              <div class="encuesta-radio-group">
                <label class="encuesta-radio-label"><input type="radio" name="p4_ha_presentado_falla" value="true" onchange="window.encuestaProductoDetalleView.toggleFalla(true)" /> <span>Sí</span></label>
                <label class="encuesta-radio-label"><input type="radio" name="p4_ha_presentado_falla" value="false" onchange="window.encuestaProductoDetalleView.toggleFalla(false)" /> <span>No</span></label>
              </div>
            </div>
          </div>

          <!-- Panel: Falla (P5-P7) -->
          <div class="encuesta-panel" id="panel-falla" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem; display: none;">
            <p style="color: var(--text-muted); margin-bottom: 1rem;">Si su equipo ha presentado alguna falla por favor responda las siguientes preguntas, de lo contrario salte a la pregunta 7.</p>
            <div id="fallaContent">
              <div class="form-group" style="margin-bottom: 1.5rem;">
                <label class="form-label">5. ¿Cómo califica el tiempo de atención, respuesta y la solución de la falla?</label>
                ${this.renderRating('p5_atencion_falla', false)}
              </div>
              <div class="form-group" style="margin-bottom: 1.5rem;">
                <label class="form-label">6. ¿La falla de su equipo fue dictaminada cómo?</label>
                <div class="encuesta-radio-group">
                  <label class="encuesta-radio-label"><input type="radio" name="p6_tipo_falla" value="garantia" /> <span>Garantía</span></label>
                  <label class="encuesta-radio-label"><input type="radio" name="p6_tipo_falla" value="reparacion" /> <span>Reparación</span></label>
                </div>
              </div>
            </div>
            <div class="form-group" style="margin-top: 1.5rem; padding-top: 1rem; border-top: 1px solid var(--border-color);">
              <label class="form-label">7. ¿Ha realizado algún servicio de mantenimiento preventivo?</label>
              <div class="encuesta-radio-group">
                <label class="encuesta-radio-label"><input type="radio" name="p7_servicio_preventivo" value="true" onchange="window.encuestaProductoDetalleView.toggleServicio(true)" /> <span>Sí</span></label>
                <label class="encuesta-radio-label"><input type="radio" name="p7_servicio_preventivo" value="false" onchange="window.encuestaProductoDetalleView.toggleServicio(false)" /> <span>No</span></label>
              </div>
            </div>
          </div>

          <!-- Panel: Mantenimiento (P8-P10) - solo visible si P7=Sí -->
          <div class="encuesta-panel" id="panel-mantenimiento" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem; display: none;">
            <p style="color: var(--text-muted); margin-bottom: 1rem;">Si ha solicitado algún mantenimiento preventivo por favor responda las siguientes preguntas.</p>
            <div class="form-group" style="margin-bottom: 1.5rem;">
              <label class="form-label">8. ¿Cómo calificaría la atención brindada por nuestro personal antes, durante y después del servicio?</label>
              ${this.renderRating('p8_atencion_servicio', false)}
            </div>
            <div class="form-group" style="margin-bottom: 1.5rem;">
              <label class="form-label">9. ¿Cómo calificaría nuestro servicio de mantenimiento preventivo (protocolo, orden y limpieza)?</label>
              ${this.renderRating('p9_protocolo_limpieza', false)}
            </div>
            <div class="form-group">
              <label class="form-label">10. ¿Cómo calificaría el desempeño de nuestro personal durante el servicio (conocimientos y habilidades)?</label>
              ${this.renderRating('p10_desempeno_personal', false)}
            </div>
          </div>

          <!-- Panel: Observaciones -->
          <div class="encuesta-panel" id="panel-observaciones" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem; display: none;">
            <div class="form-group">
              <label class="form-label">Observaciones</label>
              <textarea name="observaciones" class="form-input" rows="4" placeholder="Observaciones adicionales..." style="text-transform: uppercase;"></textarea>
            </div>
          </div>

          <!-- Panel: Responsables -->
          <div class="encuesta-panel" id="panel-responsables" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem; display: none;">
            <div class="encuesta-row-2col">
              <div class="form-group">
                <label class="form-label">Área de Posventa *</label>
                <select name="area_posventa" class="form-select">
                  <option value="">Seleccione un responsable...</option>
                  ${(this.data.responsablesPosventa || []).map(r => `
                    <option value="${r.nombre_completo}">${r.nombre_completo}</option>
                  `).join('')}
                </select>
              </div>
              <div class="form-group">
                <label class="form-label">Responsable de Calidad *</label>
                <select name="responsable_calidad" class="form-select">
                  <option value="">Seleccione un responsable...</option>
                  ${(this.data.responsablesCalidad || []).map(r => `
                    <option value="${r.nombre_completo}">${r.nombre_completo}</option>
                  `).join('')}
                </select>
              </div>
            </div>
          </div>

          <div style="display: flex; gap: 1rem; justify-content: flex-end;">
            <button type="button" class="btn btn-secondary" onclick="router.navigate('/posventa/encuestas-producto')">Cancelar</button>
            <button type="submit" class="btn btn-success">Registrar Encuesta</button>
          </div>
        </div>
      </form>
    `;

    document.getElementById('formEncuesta').addEventListener('submit', (e) => this.guardarNueva(e));

    // Buscar al presionar Enter; ocultar formulario si modifican el NS después de buscar
    const nsBuscar = document.getElementById('numSerieBuscar');
    if (nsBuscar) {
      nsBuscar.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.buscarTractor();
        }
      });
      nsBuscar.addEventListener('input', () => {
        if (this.data.tractor) {
          this.data.tractor = null;
          const fp = document.getElementById('formularioPrincipal');
          if (fp) fp.style.display = 'none';
          const result = document.getElementById('tractorResult');
          if (result) result.innerHTML = '';
        }
      });
    }

    this.injectStyles();
  },

  // =====================================================
  // FORMULARIO EDICIÓN (no completada)
  // =====================================================

  renderFormularioEdicion() {
    const container = document.getElementById('encuestaContent');
    const e = this.data.encuesta;
    const fechaFmt = (f) => f ? new Date(f).toLocaleDateString('es-MX') : '-';
    const hasFalla = e.p4_ha_presentado_falla === true || e.p4_ha_presentado_falla === 1;
    const hasServicio = e.p7_servicio_preventivo === true || e.p7_servicio_preventivo === 1;

    container.innerHTML = `
      <form id="formEditEncuesta">
        <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem;">
          <h3 style="margin-bottom: 1rem;">Datos de Identificación</h3>
          <div class="encuesta-row-2col" style="margin-bottom: 0.5rem;">
            <div><strong>Num. Serie:</strong> ${e.num_serie}</div>
            <div><strong>Marca:</strong> ${e.marca || '-'}</div>
          </div>
          <div class="encuesta-row-2col" style="margin-bottom: 0.5rem;">
            <div><strong>Modelo:</strong> ${e.modelo || '-'}</div>
            <div><strong>Usuario:</strong> ${e.usuario || '-'}</div>
          </div>
          <div class="encuesta-row-2col" style="margin-bottom: 0.5rem;">
            <div><strong>Distribuidor:</strong> ${e.distribuidor || '-'}</div>
            <div><strong>Fecha Entrega:</strong> ${fechaFmt(e.fecha_entrega)}</div>
          </div>
          <div class="encuesta-row-2col" style="margin-bottom: 0.5rem;">
            <div class="form-group">
              <label class="form-label">Fecha de Evaluación *</label>
              <input type="date" name="fecha_evaluacion" class="form-input" value="${e.fecha_evaluacion ? new Date(e.fecha_evaluacion).toISOString().split('T')[0] : ''}" />
            </div>
            <div class="form-group">
              <label class="form-label">Horas de Uso *</label>
              <input type="number" name="horas_uso" class="form-input" min="100" value="${e.horas_uso || ''}" />
            </div>
          </div>
          <div class="encuesta-row-2col">
            <div class="form-group" style="margin-bottom: 0;">
              <label class="form-label">Último Servicio *</label>
              <input type="text" name="ultimo_servicio" class="form-input" value="${e.ultimo_servicio || ''}" placeholder="Ej: 350 hr" />
            </div>
          </div>
        </div>

        <div class="encuesta-tabs-bar">
          <button type="button" class="encuesta-tab active" onclick="window.encuestaProductoDetalleView.showTabEdit('evaluacion')">Evaluación</button>
          <button type="button" class="encuesta-tab" onclick="window.encuestaProductoDetalleView.showTabEdit('falla')">Falla</button>
          <button type="button" class="encuesta-tab" id="tabMantenimientoEdit" style="${hasServicio ? '' : 'display: none;'}" onclick="window.encuestaProductoDetalleView.showTabEdit('mantenimiento')">Mantenimiento</button>
          <button type="button" class="encuesta-tab" onclick="window.encuestaProductoDetalleView.showTabEdit('observaciones')">Observaciones</button>
          <button type="button" class="encuesta-tab" onclick="window.encuestaProductoDetalleView.showTabEdit('firmas')">Firmas</button>
        </div>

        <!-- Evaluación -->
        <div class="encuesta-panel-edit" id="panel-edit-evaluacion" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem;">
          <div class="form-group" style="margin-bottom: 1.5rem;">
            <label class="form-label">1. ¿Su equipo cumplió con las expectativas de calidad y rendimiento?</label>
            ${this.renderRatingEdit('p1_calidad_rendimiento', e.p1_calidad_rendimiento)}
          </div>
          <div class="form-group" style="margin-bottom: 1.5rem;">
            <label class="form-label">2. ¿Su equipo cumplió con las expectativas de funcionamiento y potencia?</label>
            ${this.renderRatingEdit('p2_funcionamiento_potencia', e.p2_funcionamiento_potencia)}
          </div>
          <div class="form-group" style="margin-bottom: 1.5rem;">
            <label class="form-label">3. ¿Recomendaría nuestros productos AGROMX?</label>
            ${this.renderBoolEdit('p3_recomendaria', e.p3_recomendaria)}
          </div>
          <div class="form-group">
            <label class="form-label">4. ¿Su equipo ha presentado alguna falla?</label>
            ${this.renderBoolEdit('p4_ha_presentado_falla', e.p4_ha_presentado_falla, 'Sí', 'No', false, 'onchange="window.encuestaProductoDetalleView.toggleFallaEdit(this.value === \'true\')"')}
          </div>
        </div>

        <!-- Falla (P5-P7) -->
        <div class="encuesta-panel-edit" id="panel-edit-falla" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem; display: none;">
          <div id="fallaEditContent" style="${hasFalla ? '' : 'opacity: 0.5; pointer-events: none;'}">
            <p style="color: var(--text-muted); margin-bottom: 1rem;">Si su equipo ha presentado alguna falla por favor responda las siguientes preguntas, de lo contrario salte a la pregunta 7.</p>
            <div class="form-group" style="margin-bottom: 1.5rem;">
              <label class="form-label">5. ¿Cómo califica el tiempo de atención, respuesta y la solución de la falla?</label>
              ${this.renderRatingEdit('p5_atencion_falla', e.p5_atencion_falla)}
            </div>
            <div class="form-group">
              <label class="form-label">6. ¿La falla de su equipo fue dictaminada cómo?</label>
              <div class="encuesta-radio-group">
                <label class="encuesta-radio-label"><input type="radio" name="p6_tipo_falla" value="garantia" ${e.p6_tipo_falla === 'garantia' ? 'checked' : ''} /> <span>Garantía</span></label>
                <label class="encuesta-radio-label"><input type="radio" name="p6_tipo_falla" value="reparacion" ${e.p6_tipo_falla === 'reparacion' ? 'checked' : ''} /> <span>Reparación</span></label>
              </div>
            </div>
          </div>
          <div class="form-group" style="margin-top: 1.5rem; padding-top: 1rem; border-top: 1px solid var(--border-color);">
            <label class="form-label">7. ¿Ha realizado algún servicio de mantenimiento preventivo?</label>
            ${this.renderBoolEdit('p7_servicio_preventivo', e.p7_servicio_preventivo, 'Sí', 'No', false, 'onchange="window.encuestaProductoDetalleView.toggleServicioEdit(this.value === \'true\')"')}
          </div>
        </div>

        <!-- Mantenimiento (P8-P10) - solo visible si P7=Sí -->
        <div class="encuesta-panel-edit" id="panel-edit-mantenimiento" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem; display: none;">
          <p style="color: var(--text-muted); margin-bottom: 1rem;">Si ha solicitado algún mantenimiento preventivo por favor responda las siguientes preguntas.</p>
          <div class="form-group" style="margin-bottom: 1.5rem;">
            <label class="form-label">8. ¿Cómo calificaría la atención brindada antes, durante y después del servicio?</label>
            ${this.renderRatingEdit('p8_atencion_servicio', e.p8_atencion_servicio)}
          </div>
          <div class="form-group" style="margin-bottom: 1.5rem;">
            <label class="form-label">9. ¿Cómo calificaría el servicio de mantenimiento preventivo (protocolo, orden y limpieza)?</label>
            ${this.renderRatingEdit('p9_protocolo_limpieza', e.p9_protocolo_limpieza)}
          </div>
          <div class="form-group">
            <label class="form-label">10. ¿Cómo calificaría el desempeño del personal (conocimientos y habilidades)?</label>
            ${this.renderRatingEdit('p10_desempeno_personal', e.p10_desempeno_personal)}
          </div>
        </div>

        <!-- Observaciones -->
        <div class="encuesta-panel-edit" id="panel-edit-observaciones" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem; display: none;">
          <div class="form-group">
            <label class="form-label">Observaciones</label>
            <textarea name="observaciones" class="form-input" rows="4" style="text-transform: uppercase;">${e.observaciones || ''}</textarea>
          </div>
        </div>

        <!-- Firmas -->
        <div class="encuesta-panel-edit" id="panel-edit-firmas" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem; display: none;">
          <input type="hidden" name="area_posventa" value="${e.area_posventa || ''}" />
          <input type="hidden" name="responsable_calidad" value="${e.responsable_calidad || ''}" />
          <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem;">
            <div class="firma-container-new" style="text-align: center;">
              <label class="form-label firma-label">Firma Área de Posventa</label>
              <p style="margin: 0 0 0.5rem; font-weight: 600;">${e.area_posventa || 'No asignado'}</p>
              ${e.area_posventa_firma_url ? `
                <img src="${e.area_posventa_firma_url}" style="width: 100%; max-height: 80px; object-fit: contain; margin-bottom: 0.5rem;" onerror="this.style.display='none'" />
                <a href="javascript:void(0)" class="firma-limpiar" onclick="window.encuestaProductoDetalleView.limpiarFirmaExistente('posventa')">Cambiar firma</a>
              ` : `
                <div class="firma-box">
                  <canvas id="firma-posventa" class="firma-canvas-new"></canvas>
                  <span class="firma-placeholder">Toque para firmar</span>
                </div>
                <a href="javascript:void(0)" class="firma-limpiar" onclick="window.encuestaProductoDetalleView.limpiarFirma('posventa')">Limpiar</a>
              `}
            </div>
            <div class="firma-container-new" style="text-align: center;">
              <label class="form-label firma-label">Firma Responsable de Calidad</label>
              <p style="margin: 0 0 0.5rem; font-weight: 600;">${e.responsable_calidad || 'No asignado'}</p>
              ${e.responsable_calidad_firma_url ? `
                <img src="${e.responsable_calidad_firma_url}" style="width: 100%; max-height: 80px; object-fit: contain; margin-bottom: 0.5rem;" onerror="this.style.display='none'" />
                <a href="javascript:void(0)" class="firma-limpiar" onclick="window.encuestaProductoDetalleView.limpiarFirmaExistente('calidad')">Cambiar firma</a>
              ` : `
                <div class="firma-box">
                  <canvas id="firma-calidad" class="firma-canvas-new"></canvas>
                  <span class="firma-placeholder">Toque para firmar</span>
                </div>
                <a href="javascript:void(0)" class="firma-limpiar" onclick="window.encuestaProductoDetalleView.limpiarFirma('calidad')">Limpiar</a>
              `}
            </div>
          </div>
        </div>

        <!-- Indicador de cambios sin guardar -->
        <div id="unsavedIndicator" style="display: none; background: var(--warning); color: white; padding: 0.5rem 1rem; border-radius: 8px; margin-bottom: 1rem; text-align: center;">
          Hay cambios sin guardar
        </div>

        <div style="display: flex; gap: 1rem; justify-content: flex-end;">
          <button type="submit" class="btn btn-success">Guardar Cambios</button>
          ${permisos.can('encuestas_producto', 'cerrar') ? `<button type="button" class="btn btn-primary" onclick="window.encuestaProductoDetalleView.guardarYCompletar()">Completar</button>` : ''}
        </div>
      </form>
    `;

    document.getElementById('formEditEncuesta').addEventListener('submit', (e) => this.guardarEdicion(e));
    this.injectStyles();
    this.signaturePad_posventa = null;
    this.signaturePad_calidad = null;

    // Detectar cambios sin guardar
    const form = document.getElementById('formEditEncuesta');
    form.addEventListener('change', () => this._showUnsaved());
    form.addEventListener('input', () => this._showUnsaved());

    this._beforeUnloadHandler = (e) => {
      if (this._hasUnsaved) { e.preventDefault(); e.returnValue = ''; }
    };
    window.addEventListener('beforeunload', this._beforeUnloadHandler);
  },

  // =====================================================
  // VISTA COMPLETADA (solo lectura)
  // =====================================================

  renderEncuestaCompletada() {
    const container = document.getElementById('encuestaContent');
    const e = this.data.encuesta;
    const fechaFmt = (f) => f ? new Date(f).toLocaleDateString('es-MX') : '-';
    const hasFalla = e.p4_ha_presentado_falla === true || e.p4_ha_presentado_falla === 1;
    const hasServicio = e.p7_servicio_preventivo === true || e.p7_servicio_preventivo === 1;

    // Agregar botones
    const headerBtns = document.getElementById('headerButtons');
    if (headerBtns) {
      headerBtns.innerHTML = `
        <button class="btn btn-secondary" onclick="window.encuestaProductoDetalleView.volver()">← Volver</button>
        ${permisos.canPrint('encuestas_producto') ? `<button class="btn btn-primary" onclick="window.encuestaProductoDetalleView.imprimir()">🖨️ Imprimir</button>
        <button class="btn btn-success" onclick="window.encuestaProductoDetalleView.descargarPDF()">📄 Descargar PDF</button>` : ''}
      `;
    }

    container.innerHTML = `
      <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem;">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
          <h3>Datos de Identificación</h3>
          <span class="badge badge-success" style="font-size: 0.9rem; padding: 0.4rem 0.8rem;">Completada</span>
        </div>
        <div class="encuesta-row-2col" style="margin-bottom: 0.5rem;">
          <div><strong>Num. Serie:</strong> ${e.num_serie}</div>
          <div><strong>Marca:</strong> ${e.marca || '-'}</div>
        </div>
        <div class="encuesta-row-2col" style="margin-bottom: 0.5rem;">
          <div><strong>Modelo:</strong> ${e.modelo || '-'}</div>
          <div><strong>Usuario:</strong> ${e.usuario || '-'}</div>
        </div>
        <div class="encuesta-row-2col" style="margin-bottom: 0.5rem;">
          <div><strong>Distribuidor:</strong> ${e.distribuidor || '-'}</div>
          <div><strong>Fecha Entrega:</strong> ${fechaFmt(e.fecha_entrega)}</div>
        </div>
        <div class="encuesta-row-2col" style="margin-bottom: 0.5rem;">
          <div><strong>Fecha Evaluación:</strong> ${fechaFmt(e.fecha_evaluacion)}</div>
          <div><strong>Horas de Uso:</strong> ${e.horas_uso} hrs</div>
        </div>
        <div class="encuesta-row-2col">
          <div><strong>Último Servicio:</strong> ${e.ultimo_servicio || '-'}</div>
        </div>
      </div>

      <div class="encuesta-tabs-bar">
        <button class="encuesta-tab active" onclick="window.encuestaProductoDetalleView.showTabDetalle('evaluacion')">Evaluación</button>
        ${hasFalla ? '<button class="encuesta-tab" onclick="window.encuestaProductoDetalleView.showTabDetalle(\'falla\')">Falla</button>' : ''}
        ${hasServicio ? '<button class="encuesta-tab" onclick="window.encuestaProductoDetalleView.showTabDetalle(\'mantenimiento\')">Mantenimiento</button>' : ''}
        <button class="encuesta-tab" onclick="window.encuestaProductoDetalleView.showTabDetalle('observaciones')">Observaciones</button>
        <button class="encuesta-tab" onclick="window.encuestaProductoDetalleView.showTabDetalle('firmas')">Firmas</button>
      </div>

      <!-- Evaluación -->
      <div class="encuesta-panel-detalle" id="panel-detalle-evaluacion" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem;">
        <div class="form-group" style="margin-bottom: 1.5rem;">
          <label class="form-label">1. ¿Su equipo cumplió con las expectativas de calidad y rendimiento?</label>
          ${this.renderRatingEdit('p1_calidad_rendimiento', e.p1_calidad_rendimiento, true)}
        </div>
        <div class="form-group" style="margin-bottom: 1.5rem;">
          <label class="form-label">2. ¿Su equipo cumplió con las expectativas de funcionamiento y potencia?</label>
          ${this.renderRatingEdit('p2_funcionamiento_potencia', e.p2_funcionamiento_potencia, true)}
        </div>
        <div class="form-group" style="margin-bottom: 1.5rem;">
          <label class="form-label">3. ¿Recomendaría nuestros productos AGROMX?</label>
          ${this.renderBoolEdit('p3_recomendaria', e.p3_recomendaria, 'Sí', 'No', true)}
        </div>
        <div class="form-group">
          <label class="form-label">4. ¿Su equipo ha presentado alguna falla?</label>
          ${this.renderBoolEdit('p4_ha_presentado_falla', e.p4_ha_presentado_falla, 'Sí', 'No', true)}
        </div>
      </div>

      ${hasFalla ? `
        <div class="encuesta-panel-detalle" id="panel-detalle-falla" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem; display: none;">
          <div class="form-group" style="margin-bottom: 1.5rem;">
            <label class="form-label">5. ¿Cómo califica el tiempo de atención, respuesta y la solución de la falla?</label>
            ${this.renderRatingEdit('p5_atencion_falla_ro', e.p5_atencion_falla, true)}
          </div>
          <div class="form-group" style="margin-bottom: 1.5rem;">
            <label class="form-label">6. ¿La falla de su equipo fue dictaminada cómo?</label>
            <div class="encuesta-radio-group">
              <label class="encuesta-radio-label"><input type="radio" name="p6_tipo_falla_ro" value="garantia" ${e.p6_tipo_falla === 'garantia' ? 'checked' : ''} disabled /> <span>Garantía</span></label>
              <label class="encuesta-radio-label"><input type="radio" name="p6_tipo_falla_ro" value="reparacion" ${e.p6_tipo_falla === 'reparacion' ? 'checked' : ''} disabled /> <span>Reparación</span></label>
            </div>
          </div>
          <div class="form-group" style="margin-top: 1.5rem; padding-top: 1rem; border-top: 1px solid var(--border-color);">
            <label class="form-label">7. ¿Ha realizado algún servicio de mantenimiento preventivo?</label>
            ${this.renderBoolEdit('p7_servicio_preventivo_ro', e.p7_servicio_preventivo, 'Sí', 'No', true)}
          </div>
        </div>
      ` : ''}

      ${hasServicio ? `
        <div class="encuesta-panel-detalle" id="panel-detalle-mantenimiento" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem; display: none;">
          <div class="form-group" style="margin-bottom: 1.5rem;">
            <label class="form-label">8. ¿Cómo calificaría la atención brindada antes, durante y después del servicio?</label>
            ${this.renderRatingEdit('p8_atencion_servicio_ro', e.p8_atencion_servicio, true)}
          </div>
          <div class="form-group" style="margin-bottom: 1.5rem;">
            <label class="form-label">9. ¿Cómo calificaría el servicio de mantenimiento preventivo (protocolo, orden y limpieza)?</label>
            ${this.renderRatingEdit('p9_protocolo_limpieza_ro', e.p9_protocolo_limpieza, true)}
          </div>
          <div class="form-group">
            <label class="form-label">10. ¿Cómo calificaría el desempeño del personal (conocimientos y habilidades)?</label>
            ${this.renderRatingEdit('p10_desempeno_personal_ro', e.p10_desempeno_personal, true)}
          </div>
        </div>
      ` : ''}

      <div class="encuesta-panel-detalle" id="panel-detalle-observaciones" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem; display: none;">
        <div class="form-group">
          <label class="form-label">Observaciones</label>
          <textarea class="form-input" rows="4" disabled style="text-transform: uppercase;">${e.observaciones || ''}</textarea>
        </div>
      </div>

      <div class="encuesta-panel-detalle" id="panel-detalle-firmas" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem; display: none;">
        <h3 style="margin-bottom: 1rem;">Firmas</h3>
        <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem;">
          <div style="text-align: center;">
            ${e.area_posventa_firma_url ? `<img src="${e.area_posventa_firma_url}" style="width: 100%; max-height: 80px; object-fit: contain; margin-bottom: 0.5rem;" onerror="this.style.display='none'">` : ''}
            <div style="border-top: 1px solid var(--gray-400); padding-top: 0.5rem; text-align: center;">
              <strong>${e.area_posventa || '-'}</strong><br>
              <small style="color: var(--text-muted);">Área de Posventa</small>
            </div>
          </div>
          <div style="text-align: center;">
            ${e.responsable_calidad_firma_url ? `<img src="${e.responsable_calidad_firma_url}" style="width: 100%; max-height: 80px; object-fit: contain; margin-bottom: 0.5rem;" onerror="this.style.display='none'">` : ''}
            <div style="border-top: 1px solid var(--gray-400); padding-top: 0.5rem; text-align: center;">
              <strong>${e.responsable_calidad || '-'}</strong><br>
              <small style="color: var(--text-muted);">Responsable de Calidad</small>
            </div>
          </div>
        </div>
      </div>
    `;

    this.injectStyles();
  },

  // =====================================================
  // TAB NAVIGATION
  // =====================================================

  showTab(tab) {
    document.querySelectorAll('#formularioPrincipal .encuesta-tab').forEach(btn => btn.classList.remove('active'));
    document.querySelector(`#formularioPrincipal .encuesta-tab[onclick*="'${tab}'"]`)?.classList.add('active');
    document.querySelectorAll('#formularioPrincipal .encuesta-panel').forEach(p => p.style.display = 'none');
    const panel = document.getElementById(`panel-${tab}`);
    if (panel) panel.style.display = 'block';
  },

  showTabEdit(tab) {
    document.querySelectorAll('.encuesta-tab').forEach(btn => btn.classList.remove('active'));
    document.querySelector(`.encuesta-tab[onclick*="'${tab}'"]`)?.classList.add('active');
    document.querySelectorAll('.encuesta-panel-edit').forEach(p => p.style.display = 'none');
    const panel = document.getElementById(`panel-edit-${tab}`);
    if (panel) panel.style.display = 'block';
    if (tab === 'firmas' && !this.signaturePad_posventa) this.initFirmas();
  },

  showTabDetalle(tab) {
    document.querySelectorAll('.encuesta-tab').forEach(btn => btn.classList.remove('active'));
    document.querySelector(`.encuesta-tab[onclick*="'${tab}'"]`)?.classList.add('active');
    document.querySelectorAll('.encuesta-panel-detalle').forEach(p => p.style.display = 'none');
    const panel = document.getElementById(`panel-detalle-${tab}`);
    if (panel) panel.style.display = 'block';
  },

  // =====================================================
  // TOGGLE CONDICIONALES
  // =====================================================

  toggleFalla(val) {
    const section = document.getElementById('fallaContent');
    if (section) { section.style.opacity = val ? '1' : '0.5'; section.style.pointerEvents = val ? 'auto' : 'none'; }
    if (!val) { document.querySelectorAll('[name="p5_atencion_falla"], [name="p6_tipo_falla"]').forEach(r => r.checked = false); }
  },

  toggleServicio(val) {
    const tab = document.getElementById('tabMantenimientoNuevo');
    if (tab) tab.style.display = val ? '' : 'none';
    if (!val) {
      document.querySelectorAll('[name="p8_atencion_servicio"], [name="p9_protocolo_limpieza"], [name="p10_desempeno_personal"]').forEach(r => r.checked = false);
      // Si estaba en el tab mantenimiento, volver a falla
      const panel = document.getElementById('panel-mantenimiento');
      if (panel && panel.style.display !== 'none') this.showTab('falla');
    }
  },

  toggleFallaEdit(val) {
    const section = document.getElementById('fallaEditContent');
    if (section) { section.style.opacity = val ? '1' : '0.5'; section.style.pointerEvents = val ? 'auto' : 'none'; }
  },

  toggleServicioEdit(val) {
    const tab = document.getElementById('tabMantenimientoEdit');
    if (tab) tab.style.display = val ? '' : 'none';
    if (!val) {
      document.querySelectorAll('[name="p8_atencion_servicio"], [name="p9_protocolo_limpieza"], [name="p10_desempeno_personal"]').forEach(r => r.checked = false);
      // Si estaba en el tab mantenimiento, volver a falla
      const panel = document.getElementById('panel-edit-mantenimiento');
      if (panel && panel.style.display !== 'none') this.showTabEdit('falla');
    }
  },

  // =====================================================
  // FIRMAS
  // =====================================================

  async initFirmas() {
    if (!window.SignaturePad) {
      await new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/signature_pad/4.1.7/signature_pad.umd.min.js';
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }

    setTimeout(() => {
      ['posventa', 'calidad'].forEach(tipo => {
        const canvas = document.getElementById(`firma-${tipo}`);
        if (!canvas) return;

        const ratio = Math.max(window.devicePixelRatio || 1, 1);
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;
        canvas.getContext('2d').scale(ratio, ratio);

        const pad = new SignaturePad(canvas, { backgroundColor: 'rgb(255, 255, 255)', penColor: 'rgb(0, 0, 0)' });
        this[`signaturePad_${tipo}`] = pad;

        const placeholder = canvas.parentElement.querySelector('.firma-placeholder');
        const hide = () => { if (placeholder) placeholder.style.display = 'none'; };
        canvas.addEventListener('pointerdown', hide);
        canvas.addEventListener('touchstart', hide);

        // Activar "Hay cambios sin guardar" al terminar un trazo
        if (this._showUnsaved) pad.addEventListener('endStroke', () => this._showUnsaved());
      });
    }, 100);
  },

  _showProgress(message) {
    let overlay = document.getElementById('progressOverlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'progressOverlay';
      overlay.style.cssText = 'position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255,255,255,0.9); display: flex; flex-direction: column; align-items: center; justify-content: center; z-index: 9999;';
      overlay.innerHTML = `
        <div class="spinner" style="margin-bottom: 1rem;"></div>
        <p id="progressMessage" style="font-size: 1rem; font-weight: 600; color: var(--gray-700);"></p>
      `;
      document.body.appendChild(overlay);
    }
    document.getElementById('progressMessage').textContent = message;
  },

  _hideProgress() {
    const overlay = document.getElementById('progressOverlay');
    if (overlay) overlay.remove();
  },

  limpiarFirma(tipo) {
    const pad = this[`signaturePad_${tipo}`];
    if (pad) {
      pad.clear();
      const canvas = document.getElementById(`firma-${tipo}`);
      const placeholder = canvas?.parentElement.querySelector('.firma-placeholder');
      if (placeholder) placeholder.style.display = 'block';
    }
  },

  limpiarFirmaExistente(tipo) {
    const e = this.data.encuesta;
    if (tipo === 'posventa') e.area_posventa_firma_url = null;
    if (tipo === 'calidad') e.responsable_calidad_firma_url = null;
    this.renderFormularioEdicion();
    this.showTabEdit('firmas');
  },

  async toBlob(signaturePad) {
    const dataURL = signaturePad.toDataURL('image/png');
    const response = await fetch(dataURL);
    return response.blob();
  },

  async subirFirmas() {
    const urls = { area_posventa_firma_url: null, responsable_calidad_firma_url: null };
    const uploads = [];

    const numSerie = this.data.encuesta?.num_serie;

    if (this.signaturePad_posventa && !this.signaturePad_posventa.isEmpty()) {
      uploads.push(
        recepcionService.subirFirma(await this.toBlob(this.signaturePad_posventa), `firma-posventa-enc-${Date.now()}.png`, numSerie, 'encuesta_producto')
          .then(url => { urls.area_posventa_firma_url = url; })
      );
    }
    if (this.signaturePad_calidad && !this.signaturePad_calidad.isEmpty()) {
      uploads.push(
        recepcionService.subirFirma(await this.toBlob(this.signaturePad_calidad), `firma-calidad-enc-${Date.now()}.png`, numSerie, 'encuesta_producto')
          .then(url => { urls.responsable_calidad_firma_url = url; })
      );
    }

    if (uploads.length > 0) await Promise.all(uploads);
    return urls;
  },

  // =====================================================
  // ACCIONES
  // =====================================================

  async buscarTractor() {
    const numSerie = document.getElementById('numSerieBuscar').value;
    if (!numSerie) { toast.error('Ingrese el número de serie'); return; }

    const resultDiv = document.getElementById('tractorResult');
    resultDiv.innerHTML = '<p>Buscando...</p>';

    try {
      const response = await tractorService.getByNumSerie(numSerie);
      const tractor = response.data || response;
      this.data.tractor = tractor;

      resultDiv.innerHTML = '';
      document.getElementById('formularioPrincipal').style.display = 'block';
      document.getElementById('numSerie').value = numSerie;
      document.getElementById('modelo').value = tractor.modelo || '';
      document.getElementById('marca').value = tractor.marca || '';
      document.getElementById('marcaDisplay').value = tractor.marca || '';

      if (tractor.cliente) {
        document.getElementById('usuario').value = tractor.cliente.nombre || '';
      }
      if (tractor.fecha_entrega) {
        document.getElementById('fechaEntrega').value = (typeof tractor.fecha_entrega === 'string' ? tractor.fecha_entrega : '').substring(0, 10);
      }
    } catch (error) {
      resultDiv.innerHTML = `<div style="padding: 1rem; background: var(--danger); color: white; border-radius: 8px;">${error.message || 'Tractor no encontrado'}</div>`;
      document.getElementById('formularioPrincipal').style.display = 'none';
    }
  },

  async guardarNueva(ev) {
    ev.preventDefault();
    if (!this.data.tractor) { toast.error('Debe buscar un tractor'); return; }

    const formData = new FormData(ev.target);

    // Validar campos obligatorios
    if (!formData.get('usuario')) { toast.error('El campo Usuario es obligatorio'); return; }
    if (!formData.get('distribuidor')) { toast.error('Debe seleccionar un Distribuidor'); return; }
    if (!formData.get('fecha_entrega')) { toast.error('La Fecha de Entrega es obligatoria'); return; }
    if (!formData.get('fecha_evaluacion')) { toast.error('La Fecha de Evaluación es obligatoria'); return; }
    if (!formData.get('horas_uso') || parseInt(formData.get('horas_uso')) < 100) { toast.error('Las Horas de Uso son obligatorias (mínimo 100)'); return; }
    if (!formData.get('ultimo_servicio')) { toast.error('El Último Servicio es obligatorio'); return; }
    if (!formData.get('area_posventa')) { toast.error('Debe seleccionar el Área de Posventa'); this.showTab('responsables'); return; }
    if (!formData.get('responsable_calidad')) { toast.error('Debe seleccionar el Responsable de Calidad'); this.showTab('responsables'); return; }

    const t = this.data.tractor;

    const data = {
      num_serie: formData.get('num_serie'),
      usuario: formData.get('usuario'),
      distribuidor: formData.get('distribuidor'),
      marca: t?.marca || '',
      modelo: t?.modelo || '',
      fecha_entrega: formData.get('fecha_entrega'),
      fecha_evaluacion: formData.get('fecha_evaluacion'),
      horas_uso: parseInt(formData.get('horas_uso')),
      ultimo_servicio: formData.get('ultimo_servicio') || null,
      p1_calidad_rendimiento: formData.get('p1_calidad_rendimiento') ? parseInt(formData.get('p1_calidad_rendimiento')) : null,
      p2_funcionamiento_potencia: formData.get('p2_funcionamiento_potencia') ? parseInt(formData.get('p2_funcionamiento_potencia')) : null,
      p3_recomendaria: formData.get('p3_recomendaria') != null ? formData.get('p3_recomendaria') === 'true' : null,
      p4_ha_presentado_falla: formData.get('p4_ha_presentado_falla') != null ? formData.get('p4_ha_presentado_falla') === 'true' : null,
      p5_atencion_falla: formData.get('p5_atencion_falla') ? parseInt(formData.get('p5_atencion_falla')) : null,
      p6_tipo_falla: formData.get('p6_tipo_falla') || null,
      p7_servicio_preventivo: formData.get('p7_servicio_preventivo') != null ? formData.get('p7_servicio_preventivo') === 'true' : null,
      p8_atencion_servicio: formData.get('p8_atencion_servicio') ? parseInt(formData.get('p8_atencion_servicio')) : null,
      p9_protocolo_limpieza: formData.get('p9_protocolo_limpieza') ? parseInt(formData.get('p9_protocolo_limpieza')) : null,
      p10_desempeno_personal: formData.get('p10_desempeno_personal') ? parseInt(formData.get('p10_desempeno_personal')) : null,
      observaciones: formData.get('observaciones')?.toUpperCase() || null,
      area_posventa: formData.get('area_posventa') || null,
      responsable_calidad: formData.get('responsable_calidad') || null
    };

    Object.keys(data).forEach(k => { if (data[k] === null) delete data[k]; });

    try {
      this._showProgress('Creando encuesta...');
      const response = await posventaService.crearEncuestaProducto(data);
      this._hideProgress();
      toast.success('Encuesta registrada exitosamente');
      const enc = response.data || response;
      router.navigate(`/posventa/encuestas-producto/${enc.id}`);
    } catch (error) {
      this._hideProgress();
      toast.error(error.message || 'Error al registrar encuesta');
    }
  },

  async guardarEdicion(ev) {
    ev.preventDefault();
    const formData = new FormData(ev.target);
    const enc = this.data.encuesta;

    const data = {
      fecha_evaluacion: formData.get('fecha_evaluacion') || null,
      horas_uso: formData.get('horas_uso') ? parseInt(formData.get('horas_uso')) : null,
      ultimo_servicio: formData.get('ultimo_servicio') || null,
      p1_calidad_rendimiento: formData.get('p1_calidad_rendimiento') ? parseInt(formData.get('p1_calidad_rendimiento')) : null,
      p2_funcionamiento_potencia: formData.get('p2_funcionamiento_potencia') ? parseInt(formData.get('p2_funcionamiento_potencia')) : null,
      p3_recomendaria: formData.get('p3_recomendaria') != null ? formData.get('p3_recomendaria') === 'true' : null,
      p4_ha_presentado_falla: formData.get('p4_ha_presentado_falla') != null ? formData.get('p4_ha_presentado_falla') === 'true' : null,
      p5_atencion_falla: formData.get('p5_atencion_falla') ? parseInt(formData.get('p5_atencion_falla')) : null,
      p6_tipo_falla: formData.get('p6_tipo_falla') || null,
      p7_servicio_preventivo: formData.get('p7_servicio_preventivo') != null ? formData.get('p7_servicio_preventivo') === 'true' : null,
      p8_atencion_servicio: formData.get('p8_atencion_servicio') ? parseInt(formData.get('p8_atencion_servicio')) : null,
      p9_protocolo_limpieza: formData.get('p9_protocolo_limpieza') ? parseInt(formData.get('p9_protocolo_limpieza')) : null,
      p10_desempeno_personal: formData.get('p10_desempeno_personal') ? parseInt(formData.get('p10_desempeno_personal')) : null,
      observaciones: formData.get('observaciones')?.toUpperCase() || null,
      area_posventa: formData.get('area_posventa') || null,
      responsable_calidad: formData.get('responsable_calidad') || null
    };

    try {
      this._showProgress('Subiendo firmas...');
      const firmaUrls = await this.subirFirmas();
      if (firmaUrls.area_posventa_firma_url) data.area_posventa_firma_url = firmaUrls.area_posventa_firma_url;
      if (firmaUrls.responsable_calidad_firma_url) data.responsable_calidad_firma_url = firmaUrls.responsable_calidad_firma_url;

      this._showProgress('Guardando encuesta...');
      await posventaService.actualizarEncuestaProducto(enc.id, data);
      this._hideProgress();
      this._clearUnsaved();
      toast.success('Encuesta actualizada');
      await this.cargarEncuesta(enc.id);
    } catch (error) {
      this._hideProgress();
      toast.error(error.message || 'Error al actualizar');
    }
  },

  async guardarYCompletar() {
    // Si hay cambios pendientes, exigir guardar primero
    const indicator = document.getElementById('unsavedIndicator');
    if (indicator && indicator.style.display !== 'none') {
      toast.warning('Guarde los cambios antes de completar la encuesta');
      return;
    }

    const form = document.getElementById('formEditEncuesta');
    if (!form) return;

    const formData = new FormData(form);
    const enc = this.data.encuesta;

    // Validar datos editables obligatorios
    if (!formData.get('fecha_evaluacion')) { toast.error('La Fecha de Evaluación es obligatoria'); return; }
    if (!formData.get('horas_uso') || parseInt(formData.get('horas_uso')) < 100) { toast.error('Las Horas de Uso son obligatorias (mínimo 100)'); return; }
    if (!formData.get('ultimo_servicio')) { toast.error('El Último Servicio es obligatorio'); return; }

    // Validar Evaluación (P1-P4)
    if (!formData.get('p1_calidad_rendimiento') || !formData.get('p2_funcionamiento_potencia') ||
        formData.get('p3_recomendaria') == null || formData.get('p4_ha_presentado_falla') == null) {
      toast.error('Complete todas las preguntas de Evaluación');
      this.showTabEdit('evaluacion');
      return;
    }

    // Validar Falla (P5-P6 si P4=Sí, P7 siempre)
    const hasFalla = formData.get('p4_ha_presentado_falla') === 'true';
    if (hasFalla && (!formData.get('p5_atencion_falla') || !formData.get('p6_tipo_falla'))) {
      toast.error('Complete todas las preguntas de Falla');
      this.showTabEdit('falla');
      return;
    }
    if (formData.get('p7_servicio_preventivo') == null) {
      toast.error('Complete todas las preguntas de Falla');
      this.showTabEdit('falla');
      return;
    }

    // Validar Mantenimiento (P8-P10 si P7=Sí)
    const hasServicio = formData.get('p7_servicio_preventivo') === 'true';
    if (hasServicio && (!formData.get('p8_atencion_servicio') || !formData.get('p9_protocolo_limpieza') || !formData.get('p10_desempeno_personal'))) {
      toast.error('Complete todas las preguntas de Mantenimiento');
      this.showTabEdit('mantenimiento');
      return;
    }

    // Validar Firmas y responsables
    if (!formData.get('area_posventa') || !formData.get('responsable_calidad')) {
      toast.error('Debe seleccionar los responsables');
      this.showTabEdit('firmas');
      return;
    }

    // Validar firmas persistidas
    if (!enc.area_posventa_firma_url || !enc.responsable_calidad_firma_url) {
      toast.error('Faltan firmas de los responsables');
      this.showTabEdit('firmas');
      return;
    }

    if (!confirm('¿Está seguro de completar esta encuesta? Una vez completada no se podrá editar ni eliminar.')) return;

    const data = {
      fecha_evaluacion: formData.get('fecha_evaluacion'),
      horas_uso: parseInt(formData.get('horas_uso')),
      ultimo_servicio: formData.get('ultimo_servicio'),
      p1_calidad_rendimiento: parseInt(formData.get('p1_calidad_rendimiento')),
      p2_funcionamiento_potencia: parseInt(formData.get('p2_funcionamiento_potencia')),
      p3_recomendaria: formData.get('p3_recomendaria') === 'true',
      p4_ha_presentado_falla: formData.get('p4_ha_presentado_falla') === 'true',
      p5_atencion_falla: formData.get('p5_atencion_falla') ? parseInt(formData.get('p5_atencion_falla')) : null,
      p6_tipo_falla: formData.get('p6_tipo_falla') || null,
      p7_servicio_preventivo: formData.get('p7_servicio_preventivo') === 'true',
      p8_atencion_servicio: formData.get('p8_atencion_servicio') ? parseInt(formData.get('p8_atencion_servicio')) : null,
      p9_protocolo_limpieza: formData.get('p9_protocolo_limpieza') ? parseInt(formData.get('p9_protocolo_limpieza')) : null,
      p10_desempeno_personal: formData.get('p10_desempeno_personal') ? parseInt(formData.get('p10_desempeno_personal')) : null,
      observaciones: formData.get('observaciones')?.toUpperCase() || null,
      area_posventa: formData.get('area_posventa') || null,
      responsable_calidad: formData.get('responsable_calidad') || null
    };

    try {
      this._showProgress('Subiendo firmas...');
      const firmaUrls = await this.subirFirmas();
      if (firmaUrls.area_posventa_firma_url) data.area_posventa_firma_url = firmaUrls.area_posventa_firma_url;
      if (firmaUrls.responsable_calidad_firma_url) data.responsable_calidad_firma_url = firmaUrls.responsable_calidad_firma_url;

      this._showProgress('Guardando encuesta...');
      await posventaService.actualizarEncuestaProducto(enc.id, data);
      this._showProgress('Completando encuesta...');
      await posventaService.completarEncuestaProducto(enc.id);
      this._hideProgress();
      this._clearUnsaved();
      toast.success('Encuesta completada exitosamente');
      await this.cargarEncuesta(enc.id);
    } catch (error) {
      this._hideProgress();
      toast.error(error.message || 'Error al completar encuesta');
    }
  },

  async eliminarEncuesta() {
    if (!confirm('¿Está seguro de eliminar esta encuesta? Esta acción no se puede deshacer.')) return;
    try {
      this._showProgress('Eliminando encuesta...');
      await posventaService.eliminarEncuestaProducto(this.data.encuesta.id);
      this._hideProgress();
      toast.success('Encuesta eliminada');
      router.navigate('/posventa/encuestas-producto');
    } catch (error) {
      this._hideProgress();
      toast.error(error.message || 'Error al eliminar');
    }
  },

  imprimir() {
    const id = this.data.encuesta?.id;
    if (id) router.navigate(`/posventa/encuestas-producto/${id}/print`);
  },

  async descargarPDF() {
    const e = this.data.encuesta;
    if (!e) return;

    toast.info('Generando PDF...');

    try {
      if (typeof html2pdf === 'undefined') {
        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.2/html2pdf.bundle.min.js';
          script.onload = resolve;
          script.onerror = () => reject(new Error('Error al cargar librería PDF'));
          document.head.appendChild(script);
        });
      }

      const { default: PrintEncuestaProducto } = await import('./PrintEncuestaProducto.js');
      const tempDiv = document.createElement('div');
      tempDiv.style.position = 'absolute';
      tempDiv.style.left = '-9999px';
      tempDiv.id = 'tempPrintContent';
      document.body.appendChild(tempDiv);

      const response = await posventaService.obtenerEncuestaProducto(e.id);
      const encuesta = response.data || response;
      PrintEncuestaProducto.renderPrint.call(PrintEncuestaProducto, encuesta);

      const printContainer = document.querySelector('#content .print-container');
      const clonedContent = printContainer.cloneNode(true);
      const style = document.createElement('style');
      style.textContent = '.print-container { padding: 5mm !important; } * { margin: 0; }';
      clonedContent.prepend(style);
      tempDiv.appendChild(clonedContent);

      const opt = {
        margin: [5, 5, 5, 5],
        filename: `AMX-PVTA-FR-04_${e.num_serie}.pdf`,
        image: { type: 'png', quality: 1 },
        html2canvas: { scale: 3, useCORS: true, scrollY: 0, letterRendering: true },
        jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' },
        pagebreak: { mode: 'avoid-all' }
      };

      await html2pdf().set(opt).from(clonedContent).save();
      document.body.removeChild(tempDiv);

      this.renderEncuestaCompletada();
      toast.success('PDF descargado');
    } catch (error) {
      toast.error('Error al generar PDF');
      console.error(error);
    }
  },

  getCalificacionBadge(cal) {
    if (cal >= 4) return 'badge-success';
    if (cal >= 3) return 'badge-warning';
    return 'badge-danger';
  },

  volver() {
    if (this._hasUnsaved) {
      if (!confirm('Hay cambios sin guardar. ¿Está seguro de salir?')) return;
    }
    this._clearUnsaved();
    router.navigate('/posventa/encuestas-producto');
  },

  _showUnsaved() {
    this._hasUnsaved = true;
    const indicator = document.getElementById('unsavedIndicator');
    if (indicator) indicator.style.display = 'block';
  },

  _clearUnsaved() {
    this._hasUnsaved = false;
    const indicator = document.getElementById('unsavedIndicator');
    if (indicator) indicator.style.display = 'none';
    if (this._beforeUnloadHandler) window.removeEventListener('beforeunload', this._beforeUnloadHandler);
  }
};
